module.exports = __webpack_public_path__ + "img/Page3-min.ca6e44e9.jpg";